import { mutate } from 'swr';
import useSWRImmutable from 'swr/immutable';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

const getNotifications = async ({ country }) => {
    try {
        const res = await axFetch.get(`${settings.urls.notifications.getMyNotifications}?sort=-createdAt`);
        const filteredNotifications = res.data.results.filter((notification) => {
            return (
                notification.content?.category &&
                (notification.appIds.length === 0 || notification.appIds.includes(settings.app.id)) &&
                (notification.countryIds.length === 0 || notification.countryIds.includes(country.id))
            );
        });
        const unreadedNotifications = filteredNotifications.filter((n) => {
            return Boolean(!n.readedOn);
        });
        const readedNotifications = filteredNotifications.filter((n, i) => {
            return Boolean(n.readedOn);
        });
        return { unreadedNotifications, readedNotifications };
    } catch (error) {
        return { unreadedNotifications: [], readedNotifications: [] };
    }
};

export const useNotifications = ({ country }: { country: string }) => {
    let key = {
        key: 'notifications',
        country,
    };
    if (!country) key = null;
    return useSWRImmutable(key, ({ country }) =>
        getNotifications({
            country,
        })
    );
};

export const markAllNotificationsAsRead = async ({ unreadedNotifications, country }) => {
    const url = settings.urls.notifications.readMyNotifications;
    const body = {
        ids: unreadedNotifications.map((ur) => {
            return ur._id;
        }),
    };
    await axFetch.post(url, body);
    const key = {
        key: 'notifications',
        country,
    };
    mutate(key);
};

export const markAsRead = async ({ id, country }: { id: number }) => {
    const url = settings.urls.notifications.readMyNotifications;
    const body = {
        ids: [id],
    };
    await axFetch.post(url, body);
    const key = {
        key: 'notifications',
        country,
    };
    mutate(key);
};

export const markAsClicked = async ({ id, country }: { id: number }) => {
    const url = `${settings.urls.notifications.getMyNotifications}/${id}/click`;
    await axFetch.post(url);
    const key = {
        key: 'notifications',
        country,
    };
    mutate(key);
};
